import { render, staticRenderFns } from "./PatInboxPage.vue?vue&type=template&id=132f7532"
import script from "./PatInboxPage.vue?vue&type=script&lang=js"
export * from "./PatInboxPage.vue?vue&type=script&lang=js"
import style0 from "./PatInboxPage.vue?vue&type=style&index=0&id=132f7532&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports